<template>
    <form ref="formDOM" method="post" enctype="application/x-www-form-urlencoded" target="render-frame">
        <input type="hidden" name="account" :value="oceanpaymentJSON.account" />
        <input type="hidden" name="terminal" :value="oceanpaymentJSON.terminal" />
        <input type="hidden" name="signValue" :value="oceanpaymentJSON.signValue" />
        <input type="hidden" name="backUrl" :value="oceanpaymentJSON.backUrl" />
        <input type="hidden" name="methods" :value="oceanpaymentJSON.methods" />
        <input type="hidden" name="order_number" :value="oceanpaymentJSON.order_number" />
        <input type="hidden" name="order_currency" :value="oceanpaymentJSON.order_currency" />
        <input type="hidden" name="order_amount" :value="oceanpaymentJSON.order_amount" />
        <input type="hidden" name="billing_firstName" :value="oceanpaymentJSON.billing_firstName" />
        <input type="hidden" name="billing_lastName" :value="oceanpaymentJSON.billing_lastName" />
        <input type="hidden" name="billing_email" :value="oceanpaymentJSON.billing_email" />
        <input type="hidden" name="billing_country" :value="oceanpaymentJSON.billing_country" />
        <input type="hidden" name="billing_state" :value="oceanpaymentJSON.billing_state" />
        <input type="hidden" name="productSku" :value="oceanpaymentJSON.productSku" />
        <input type="hidden" name="productName" :value="oceanpaymentJSON.productName" />
        <input type="hidden" name="productNum" :value="oceanpaymentJSON.productNum" />
        <input type="hidden" name="productPrice" :value="oceanpaymentJSON.productPrice" />
        <input type="hidden" name="language" :value="i18n.global.locale" />
        <input type="hidden" name="noticeUrl" :value="oceanpaymentJSON.noticeUrl" />
    </form>
    <iframe ref="iframeDOM" name="render-frame"></iframe>
</template>
<script setup>
import payment from './js/payment';
import { onMounted, ref, getCurrentInstance } from 'vue';

const {  i18n } = getCurrentInstance().appContext.config.globalProperties;
const oceanpayment = localStorage.getItem('oceanpayment');
const oceanpaymentJSON = JSON.parse(oceanpayment);
const formDOM = ref(null);
const iframeDOM = ref(null);


onMounted(() => {
    window.addEventListener('message', (event) => {
        if (event.data.callback) {
            payment.directBackGangplankHandle(event.data.callback);
            localStorage.removeItem('oceanpayment');
        }
    });
    formDOM.value.setAttribute('action', oceanpaymentJSON.api);
    formDOM.value.submit();
});

</script>
<style scoped lang="scss">
iframe {
    width: 100vw;
    height: 100vh;
    border: medium none;
}
</style>